<template>
  <section class="p-3">
    <v-row align="center" class="ms-1 mb-2">
      <v-btn-toggle v-model="toggle" dense depressed color="primary" rounded>
        <v-btn :value="1" class="w_100px" @click="getAllTxns(true)">
          Today
        </v-btn>
        <v-btn :value="2" class="w_100px" @click="getAllTxns(false)">
          All
        </v-btn>
      </v-btn-toggle>
    </v-row>
    <v-row>
      <v-col class="pb-2" cols="12" lg="3" md="4" sm="12" xs="12">
        <v-card
          :disabled="!selectedToday"
          @click="navigateSearchTxn()"
          height="100px"
          class="main-bg"
        >
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-avatar class="ma-3" size="50" tile>
              <img src="../assets/send-money.png" />
            </v-avatar>
            <div>
              <v-card-title class="caption text-end font-weight-bold"
                >Send Transactions:<span class="text-h6"
                  >{{ totalTransastions && totalTransastions.no_of_txns }}
                </span></v-card-title
              >

              <v-card-subtitle class="text-end">{{
                totalTransastions && totalTransastions.total_amount
              }}</v-card-subtitle>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col class="pb-2" cols="12" lg="3" md="4" sm="12" xs="12">
        <v-card
          class="main-send-bg"
          @click="navigateSearchTxn('6', null)"
          height="100px"
        >
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-avatar class="ma-3" size="50" tile>
              <img src="../assets/check.png" />
            </v-avatar>
            <div>
              <v-card-title class="caption text-end font-weight-bold"
                >Paid Transactions:<span class="text-h6"
                  >{{ paidTransactions && paidTransactions.no_of_txns }}
                </span></v-card-title
              >

              <v-card-subtitle class="text-end">{{
                paidTransactions && paidTransactions.total_amount
              }}</v-card-subtitle>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col class="pb-2" cols="12" lg="3" md="2" sm="12" xs="12">
        <v-card
          class="main-comp-bg"
          @click="navigateSearchTxn('2', '4')"
          height="100px"
        >
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-avatar class="ma-3" size="50" tile>
              <img src="../assets/compliance.png" />
            </v-avatar>
            <div>
              <v-card-title class="caption font-weight-bold"
                ><span class="text-end text-h6"
                  >{{ complianceHoldlist.no_of_txns }}
                </span></v-card-title
              >

              <v-card-subtitle class="text-end">Compliance Txn</v-card-subtitle>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col class="pb-2" cols="12" lg="3" md="2" sm="12" xs="12">
        <v-card
          class="main-hold-bg"
          @click="navigateSearchTxn('2', '2')"
          height="100px"
        >
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-avatar class="ma-3" size="50" tile>
              <img src="../assets/pause.png" />
            </v-avatar>
            <div>
              <v-card-title class="caption font-weight-bold"
                ><span class="text-end text-h6"
                  >{{ holdTransactions.no_of_txns }}
                </span></v-card-title
              >

              <v-card-subtitle class="text-end">Hold Txn</v-card-subtitle>
            </div>
          </div>
        </v-card>
      </v-col>
      <!-- <v-col class="pb-2" cols="12" lg="3" md="2" sm="12" xs="12">
        <v-card class="main-com-bg" @click="alert('hi')">
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-avatar class="ma-3"  size="50" tile>
              <img src="../assets/cash.png">
            </v-avatar>
            <div>
              <v-card-title class="caption font-weight-bold"
                ><span class="text-end text-h6">245367 </span></v-card-title
              >

              <v-card-subtitle class="text-end"
                >Commission Gain</v-card-subtitle
              >
            </div>
          </div>
        </v-card>
      </v-col> -->
    </v-row>
    <v-hover class="fixbottom" v-slot:default="{ hover }" open-delay="200">
      <v-btn
        color="primary"
        @click="pushToCustList"
        class="ma-2 white--text text-capitalize pa-6"
        rounded
      >
        <v-avatar class="ma-3" size="35" tile>
          <img src="../assets/send.png" />
        </v-avatar>
        <v-expand-x-transition>
          <span v-if="hover" class=" ">
            Send Money
            <br />
            <span class="caption">Send Money Now...</span>
          </span>
        </v-expand-x-transition>
      </v-btn>
    </v-hover>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>
<script>
import Loading from "vue-loading-overlay";
import AgentService from "@/services/agentService/AgentService";

export default {
  name: "Dashboard",
  data() {
    return {
      loader: false,
      toggle: 1,
      showFirstData: true,
      target_currency: "INR",
      selectedToday: true,
      totalUsers: [],
      totalTransastions: [],
      paidTransactions: [],
      holdTransactions: [],
      complianceHoldlist: [],
      no_of_days: 30,
      isKey: 1,
      selectedCountry: {
        iso2: "IN",
        iso3: "IND",
        name: "India",
        currency: "INR",
      },
      selected_flag: "IN",
    };
  },
  watch: {
    selectedCountry(val) {
      this.selected_flag = val.iso2;
      this.target_currency = val.currency;
      this.getExchangeRate(val.iso3);
      console.log(this.target_currency, "target_currency");
    },
  },
  mounted() {
    this.getAllTxns(true);
  },
  methods: {
    getAllTxns(value) {
      this.selectedToday = value;
      this.getDashboardTransactions(null, null);
      this.getDashboardTransactions("02", "04");
      this.getDashboardTransactions("02", "02");
      this.getDashboardTransactions("06", null);
    },
    async getDashboardTransactions(code, stage) {
      this.loader = true;
      const params = {
        today: this.selectedToday,
        transaction_status: code,
        transaction_stage: stage,
      };
      try {
        const responseData = await AgentService.getDashboardTxns(params);
        if (responseData && responseData.data.status_code === 200) {
          switch (params.transaction_status) {
            case null:
              this.totalTransastions = responseData.data.data[0];
              break;
            case "06":
              this.paidTransactions = responseData.data.data[0];
              break;
            default:
              // Handle other cases
              break;
          }
          if (
            params.transaction_status == "02" &&
            params.transaction_stage == "02"
          ) {
            this.holdTransactions = responseData.data.data[0];
          }
          if (
            params.transaction_status == "02" &&
            params.transaction_stage == "04"
          ) {
            this.complianceHoldlist = responseData.data.data[0];
          }
          this.loader = false;
        }
        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },

    pushToCustList() {
      this.$router.push("/CustomerList");
      this.$emit("componentTab", {
        title: "Send Transaction",
        path: "/CustomerList",
        close: true,
      });
    },

    navigateSearchTxn(value, stage) {
      if (this.selectedToday == true) {
        this.$router.push({
          path: "/txnDetails",
          query: {
            txn_status: value,
            txn_stage: stage,
            is_today: this.selectedToday,
          },
        });
      } else {
        this.$router.push({
          path: "/txnDetails",
          query: {
            txn_status: value,
            txn_stage: stage,
          },
        });
      }
    },
  },

  components: {
    Loading,
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.fixbottom {
  position: fixed;
  bottom: 60px;
  right: 0;
  z-index: 1;
}
.w_100px {
  width: 100px;
}

.main-bg {
  background-color: #ffff;
  background-image: linear-gradient(315deg, #ffff 0%, #80d0c7 100%);
}
.main-send-bg {
  background-color: #ffff;
  background-image: linear-gradient(315deg, #ffff 0%, #9dd080 100%);
}
.main-comp-bg {
  background-color: #ffff;
  background-image: linear-gradient(315deg, #ffff 0%, #80a1d0 100%);
}
.main-hold-bg {
  background-color: #ffff;
  background-image: linear-gradient(315deg, #ffff 0%, #d080c7 100%);
}
.main-com-bg {
  background-color: #ffff;
  background-image: linear-gradient(315deg, #ffff 0%, #d0809b 100%);
}
.bold {
  // font-weight:300;
  // color: black;
  font-size: medium;
}
</style>
